<template>
  <transition name="confirm">
    <div
      class="confirm"
      v-show="isShow"
    >
      <div class="modalBg" />
      <div
        class="modalBox"
        :class="obj.class"
      >
        <div class="title">
          {{ obj.title }}
        </div>
        <div
          :class="['text',obj.class == 1 ? redcolor : '',]"
          v-if="!obj.dangerouslyUseHTMLString"
        >
          {{ obj.text }}
        </div>
        <div
          class="text"
          v-else
          v-html="obj.text"
        />
        <div class="footer">
          <button
            class="btn"
            @click="no()"
            v-if="obj.btn.no"
          >
            {{ obj.btn.no }}
          </button>
          <button
            class="btn"
            @click="ok()"
            v-if="obj.btn.ok"
          >
            {{ obj.btn.ok }}
          </button>
        </div>
      </div>
    </div>
    <!-- 古诗词页面提交多了背景图片 -->
  </transition>
</template>

<script>
/* eslint-disable */
export default {
  data() {
    return {
      isShow: true,
      obj: {
        title: '',
        text: '',
        dangerouslyUseHTMLString: false, // 内容是否是html
        btn: {
          ok: '',
          no: '',
        },
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.modalBg {
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.4);
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2100;
}
.modalBox {
  width: 560px;
	border-radius: 24px;
  background: #fff;
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%) scale(0.5);
  z-index: 2101;
}
.title {
	font-size: 36px;
	color: #111F2C;
    text-align: center;
    line-height: 50px;
    margin: 40px 45px 0;
}
.text {
	font-size: 30px;
	color: rgba(17,31,44,0.56);
	text-align: center;
	line-height: 42px;
  overflow: hidden;
  margin: 20px 45px 30px;
}
.footer {
    width: 560px;
    height: 96px;
    border-top: 1PX solid rgba(17,31,44,0.12);
	display: flex;
    flex-direction: row;
    border-bottom-right-radius: 24px;
    border-bottom-left-radius: 24px;
    overflow: hidden;
}
.btn {
	min-width: 50%;
	height: 96px;
	font-size: 34px;
	color:#0089FF;
	line-height: 96px;
    font-weight: 400;
	text-align: center;
    outline: none;
    flex-grow: 1;
    &:active {
        background: #e6e6e6;
    }
}
.btn:nth-child(2) {
    border-left: 1PX solid rgba(17,31,44,0.12);
    font-weight: 500;
}
.welcome{
    .btn:nth-child(1) {
        color: #ccc;
    }
}
.redcolor{
  color:red !important;
}
</style>
